(function () {
  'use strict';

  if (window.MerlonsProductActions) return;
  window.MerlonsProductActions = true;

  /* Minicom's legacy quick-view always calls Shopify.PaymentButton.init().
     Dynamic payment buttons are intentionally disabled for Merlons, so keep
     that legacy callback harmless when Shopify does not load its PayPal SDK. */
  window.Shopify = window.Shopify || {};
  window.Shopify.PaymentButton = window.Shopify.PaymentButton || { init: function () {} };

  function parseNumber(value, fallback) {
    var parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function normaliseQuantity(input) {
    var min = parseNumber(input.min, 1);
    var max = parseNumber(input.max, Infinity);
    var step = parseNumber(input.step, 1);
    var value = parseNumber(input.value, min);

    if (max > 0) value = Math.min(value, max);
    value = Math.max(value, min);
    input.value = String(Math.max(min, Math.round(value / step) * step));
  }

  function setQuantity(control, direction) {
    var input = control.querySelector('input[name="quantity"]');
    if (!input || input.disabled) return;

    normaliseQuantity(input);
    var min = parseNumber(input.min, 1);
    var max = parseNumber(input.max, Infinity);
    var step = parseNumber(input.step, 1);
    var value = parseNumber(input.value, min) + (direction === 'increase' ? step : -step);

    if (max > 0) value = Math.min(value, max);
    input.value = String(Math.max(value, min));
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function variantIsAvailable(form) {
    var variantInput = form.querySelector('input[name="id"]');
    if (!variantInput) return false;
    var variantSelect = form.querySelector('select#productSelect, select#productSelectStick');
    var variantOption = variantSelect && Array.prototype.find.call(variantSelect.options, function (option) {
      return option.value === variantInput.value;
    });
    return !variantOption || !variantOption.disabled;
  }

  function updateBuyNow(form) {
    var button = form.querySelector('[data-merlons-buy-now]');
    if (!button) return;
    button.disabled = !variantIsAvailable(form);
  }

  function updateAllBuyNow() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(updateBuyNow);
  }

  function addErrorMessage(button) {
    return (button && button.dataset.errorMessage)
      || (window.theme && window.theme.strings && window.theme.strings.add_error)
      || '';
  }

  function themeString(key, fallback) {
    return (window.theme && window.theme.strings && window.theme.strings[key]) || fallback || '';
  }

  function legacyCopyText(value) {
    return new Promise(function (resolve, reject) {
      var textarea = document.createElement('textarea');
      textarea.value = value;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      textarea.style.pointerEvents = 'none';
      document.body.appendChild(textarea);
      textarea.select();
      textarea.setSelectionRange(0, value.length);

      try {
        if (!document.execCommand('copy')) throw new Error('Copy command failed');
        resolve();
      } catch (error) {
        reject(error);
      } finally {
        textarea.remove();
      }
    });
  }

  function copyText(value) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(value).catch(function () {
        return legacyCopyText(value);
      });
    }
    return legacyCopyText(value);
  }

  function copyStatusNode() {
    var status = document.getElementById('MerlonsSkuCopyStatus');
    if (status) return status;

    status = document.createElement('span');
    status.id = 'MerlonsSkuCopyStatus';
    status.className = 'merlons-visually-hidden';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.setAttribute('aria-atomic', 'true');
    document.body.appendChild(status);
    return status;
  }

  function collectionCardProductData(card) {
    var raw = card && card.getAttribute('data-json-product');
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch (error) {
      return null;
    }
  }

  function collectionCardSelectedVariant(card) {
    var productData = collectionCardProductData(card);
    if (!productData || !Array.isArray(productData.variants)) return null;
    var variantInput = card.querySelector('.item-product__popup--variant .current_variant_id[name="id"]')
      || card.querySelector('.merlons-collection-card__purchase input[name="id"]');
    if (!variantInput || !variantInput.value) return null;
    return productData.variants.find(function (variant) {
      return String(variant.id) === String(variantInput.value);
    }) || null;
  }

  function syncCollectionCardVariantState(card) {
    if (!card || !card.classList.contains('merlons-collection-card') || !card.closest('.template-collection') || !card.closest('#product-grid')) return;
    var variant = collectionCardSelectedVariant(card);
    if (!variant) return;

    var skuButton = card.querySelector('[data-merlons-copy-sku]');
    if (skuButton) {
      var sku = typeof variant.sku === 'string' ? variant.sku.trim() : '';
      var skuText = skuButton.querySelector('.merlons-product-card-sku__text');
      if (skuText) skuText.textContent = sku || '—';
      skuButton.disabled = !sku;
      skuButton.classList.toggle('merlons-product-card-sku__value--empty', !sku);
      window.clearTimeout(skuButton.merlonsCopyTimer);
      delete skuButton.dataset.merlonsCopyState;
      delete skuButton.dataset.merlonsCopyFeedback;
      if (sku) {
        skuButton.title = skuButton.dataset.copyLabel || '';
        skuButton.setAttribute('aria-label', (skuButton.dataset.copyLabel || '') + ': ' + sku);
      } else {
        skuButton.removeAttribute('title');
        skuButton.setAttribute('aria-label', (skuButton.dataset.codeLabel || '') + ': —');
      }
    }

    var stockMeta = card.querySelector('.merlons-product-card-meta');
    var stockState = stockMeta && stockMeta.querySelector('.product__available');
    var stockText = stockMeta && stockMeta.querySelector('[data-merlons-card-stock-text]');
    if (stockState) {
      stockState.classList.toggle('in-stock', Boolean(variant.available));
      stockState.classList.toggle('sold-out', !variant.available);
    }
    if (stockText) {
      stockText.textContent = variant.available ? stockMeta.dataset.inStockLabel : stockMeta.dataset.soldOutLabel;
    }

    var cartButton = card.querySelector('.merlons-collection-card__purchase [data-btn-addToCart]');
    if (cartButton) {
      var isPreorder = variant.available
        && variant.inventory_policy === 'continue'
        && variant.inventory_management === 'shopify';
      cartButton.disabled = !variant.available;
      cartButton.classList.toggle('disabled', !variant.available);
      cartButton.setAttribute(
        'aria-label',
        !variant.available
          ? cartButton.dataset.soldoutLabel
          : (isPreorder ? cartButton.dataset.preorderLabel : cartButton.dataset.addLabel)
      );
    }
  }

  function queueCollectionCardVariantSync(control) {
    var card = control && control.closest && control.closest('.merlons-collection-card');
    if (!card || !card.closest('.template-collection') || !card.closest('#product-grid')) return;
    window.setTimeout(function () { syncCollectionCardVariantState(card); }, 0);
  }

  function showSkuCopyFeedback(target, message, state) {
    var status = copyStatusNode();
    status.textContent = '';
    window.setTimeout(function () { status.textContent = message; }, 0);

    target.dataset.merlonsCopyFeedback = message;
    target.dataset.merlonsCopyState = state;
    window.clearTimeout(target.merlonsCopyTimer);
    target.merlonsCopyTimer = window.setTimeout(function () {
      delete target.dataset.merlonsCopyState;
      delete target.dataset.merlonsCopyFeedback;
    }, 1800);
  }

  async function copySku(target) {
    var sku = target.textContent.trim();
    if (!sku) return;

    try {
      await copyText(sku);
      showSkuCopyFeedback(target, themeString('sku_copied', target.dataset.copySuccess), 'success');
    } catch (error) {
      showSkuCopyFeedback(target, themeString('sku_copy_failed', target.dataset.copyError), 'error');
    }
  }

  function relatedCarouselForPager(pager) {
    var section = pager && pager.closest('[data-merlons-related-section]');
    return section && section.querySelector('[data-merlons-related-carousel]');
  }

  function relatedCarouselNumber(carousel, name, fallback) {
    return parseNumber(carousel.getAttribute('data-' + name), fallback);
  }

  function relatedCarouselBoolean(carousel, name, fallback) {
    var value = carousel.getAttribute('data-' + name);
    if (value === null) return fallback;
    return value === '' || value === 'true' || value === '1';
  }

  function relatedCarouselLabels(carousel) {
    var locale = (document.documentElement.lang || 'ka').toLowerCase().split('-')[0];
    var defaults = locale === 'ru'
      ? { next: 'Далее', previous: 'Назад' }
      : locale === 'en'
        ? { next: 'Next', previous: 'Previous' }
        : { next: 'შემდეგი', previous: 'წინა' };

    return {
      next: carousel.getAttribute('data-next-label') || defaults.next,
      previous: carousel.getAttribute('data-previous-label') || defaults.previous
    };
  }

  function localizeRelatedCarouselArrows(carousel) {
    var labels = relatedCarouselLabels(carousel);
    carousel.querySelectorAll('.arrow-next, .slick-next').forEach(function (arrow) {
      arrow.setAttribute('aria-label', labels.next);
      arrow.innerHTML = '<svg class="merlons-slider-arrow" viewBox="0 0 24 24" aria-hidden="true"><path d="m9 5 7 7-7 7"/></svg>';
    });
    carousel.querySelectorAll('.arrow-prev, .slick-prev').forEach(function (arrow) {
      arrow.setAttribute('aria-label', labels.previous);
      arrow.innerHTML = '<svg class="merlons-slider-arrow" viewBox="0 0 24 24" aria-hidden="true"><path d="m15 5-7 7 7 7"/></svg>';
    });
  }

  function startRelatedCarousel(carousel) {
    if (!carousel || !window.jQuery || typeof window.jQuery.fn.slick !== 'function') return false;
    if (carousel.classList.contains('slick-initialized')) return true;

    var slider = window.jQuery(carousel);
    var itemsXxl = relatedCarouselNumber(carousel, 'items_xxl', 4);
    var itemsXl = relatedCarouselNumber(carousel, 'items_xl', itemsXxl);
    var itemsLg = relatedCarouselNumber(carousel, 'items_lg', itemsXl);
    var itemsMd = relatedCarouselNumber(carousel, 'items_md', 3);
    var itemsSm = relatedCarouselNumber(carousel, 'items_sm', 2);
    var itemsXs = relatedCarouselNumber(carousel, 'items_xs', 2);
    var slidesToScroll = relatedCarouselNumber(carousel, 'oneslider', 0) ? 1 : itemsXxl;
    var swipe = relatedCarouselBoolean(carousel, 'swipe', true);
    var freeScroll = relatedCarouselBoolean(carousel, 'free_scroll', false);
    var labels = relatedCarouselLabels(carousel);

    slider.slick({
      nextArrow: '<button type="button" class="arrow-next" aria-label="' + labels.next.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;') + '"><svg class="merlons-slider-arrow" viewBox="0 0 24 24" aria-hidden="true"><path d="m9 5 7 7-7 7"/></svg></button>',
      prevArrow: '<button type="button" class="arrow-prev" aria-label="' + labels.previous.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;') + '"><svg class="merlons-slider-arrow" viewBox="0 0 24 24" aria-hidden="true"><path d="m15 5-7 7 7 7"/></svg></button>',
      rtl: document.documentElement.classList.contains('lang-rtl'),
      slidesToShow: itemsXxl,
      slidesToScroll: slidesToScroll,
      arrows: relatedCarouselBoolean(carousel, 'nav', true),
      dots: relatedCarouselBoolean(carousel, 'dots', false),
      infinite: relatedCarouselBoolean(carousel, 'loop', true),
      swipe: swipe,
      swipeToSlide: freeScroll,
      draggable: swipe,
      touchMove: swipe,
      waitForAnimate: !freeScroll,
      responsive: [
        { breakpoint: 1441, settings: { slidesToShow: itemsXl, slidesToScroll: slidesToScroll === 1 ? 1 : itemsXl } },
        { breakpoint: 1200, settings: { slidesToShow: itemsLg, slidesToScroll: slidesToScroll === 1 ? 1 : itemsLg } },
        { breakpoint: 992, settings: { slidesToShow: itemsMd, slidesToScroll: slidesToScroll === 1 ? 1 : itemsMd } },
        { breakpoint: 768, settings: { slidesToShow: itemsSm, slidesToScroll: slidesToScroll === 1 ? 1 : itemsSm } },
        { breakpoint: 576, settings: { slidesToShow: itemsXs, slidesToScroll: slidesToScroll === 1 ? 1 : itemsXs } },
        { breakpoint: 340, settings: { slidesToShow: Math.min(itemsXs, 2), slidesToScroll: 1 } }
      ]
    });

    localizeRelatedCarouselArrows(carousel);
    return carousel.classList.contains('slick-initialized');
  }

  function disconnectRelatedCarousel(carousel) {
    if (!carousel) return;
    if (carousel.merlonsRelatedCarouselObserver) {
      carousel.merlonsRelatedCarouselObserver.disconnect();
      delete carousel.merlonsRelatedCarouselObserver;
    }
  }

  function destroyRelatedCarousel(carousel) {
    disconnectRelatedCarousel(carousel);
    if (!window.jQuery || typeof window.jQuery.fn.slick !== 'function') return;

    var slider = window.jQuery(carousel);
    slider.off('.merlonsRelated');
    if (carousel.classList.contains('slick-initialized')) slider.slick('unslick');
  }

  function disconnectRelatedPager(pager) {
    if (!pager) return;
    if (pager.merlonsRelatedPagerObserver) {
      pager.merlonsRelatedPagerObserver.disconnect();
      delete pager.merlonsRelatedPagerObserver;
    }
    if (pager.merlonsRelatedPagerIdle != null) {
      if (typeof window.cancelIdleCallback === 'function') {
        window.cancelIdleCallback(pager.merlonsRelatedPagerIdle);
      } else {
        window.clearTimeout(pager.merlonsRelatedPagerIdle);
      }
      delete pager.merlonsRelatedPagerIdle;
    }
  }

  function initializeRelatedCarouselNow(carousel, pager) {
    if (!carousel || !carousel.isConnected || carousel.dataset.merlonsRelatedCarouselBound === 'true') return true;

    disconnectRelatedCarousel(carousel);
    carousel.dataset.merlonsRelatedCarouselBound = 'true';
    var slider = window.jQuery(carousel);
    slider.on('init.merlonsRelated reInit.merlonsRelated', function () {
      localizeRelatedCarouselArrows(carousel);
    });
    try {
      var initialized = startRelatedCarousel(carousel);
      localizeRelatedCarouselArrows(carousel);
      if (initialized && pager && pager.dataset.nextUrl) {
        observeRelatedProductPages(pager);
      }
      if (!initialized) {
        slider.off('.merlonsRelated');
        delete carousel.dataset.merlonsRelatedCarouselBound;
      }
      return initialized;
    } catch (error) {
      slider.off('.merlonsRelated');
      delete carousel.dataset.merlonsRelatedCarouselBound;
      return false;
    }
  }

  function initializeRelatedCarousel(carousel, pager) {
    if (!carousel || !carousel.isConnected || !window.jQuery || typeof window.jQuery.fn.slick !== 'function') return false;
    if (carousel.dataset.merlonsRelatedCarouselBound === 'true') return true;

    if (carousel.merlonsRelatedCarouselObserver) return true;
    if (!('IntersectionObserver' in window)) return initializeRelatedCarouselNow(carousel, pager);

    var observer = new window.IntersectionObserver(function (entries) {
      if (carousel.merlonsRelatedCarouselObserver !== observer) return;
      if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
      observer.disconnect();
      delete carousel.merlonsRelatedCarouselObserver;
      initializeRelatedCarouselNow(carousel, pager);
    }, {
      rootMargin: '150px 0px',
      threshold: 0
    });
    carousel.merlonsRelatedCarouselObserver = observer;
    observer.observe(carousel);
    return true;
  }

  function initializeRelatedProducts(root) {
    var scope = root || document;

    scope.querySelectorAll('[data-merlons-related-carousel]').forEach(function (carousel) {
      var section = carousel.closest('[data-merlons-related-section]');
      var pager = section && section.querySelector('[data-merlons-related-pager]');
      initializeRelatedCarousel(carousel, pager);
    });
  }

  function observeRelatedProductPages(pager) {
    if (!pager || !pager.dataset.nextUrl || pager.dataset.merlonsRelatedObserved === 'true' || pager.merlonsRelatedPagerObserver || pager.merlonsRelatedPagerIdle != null) return;

    pager.dataset.merlonsRelatedObserved = 'true';
    var section = pager.closest('[data-merlons-related-section]');
    var startLoading = function () {
      if (!pager.isConnected || !pager.dataset.nextUrl) return;
      loadRelatedProducts(pager);
    };

    if ('IntersectionObserver' in window && section) {
      var observer = new window.IntersectionObserver(function (entries) {
        if (pager.merlonsRelatedPagerObserver !== observer) return;
        if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
        observer.disconnect();
        delete pager.merlonsRelatedPagerObserver;
        startLoading();
      }, {
        rootMargin: '900px 0px',
        threshold: 0
      });
      pager.merlonsRelatedPagerObserver = observer;
      observer.observe(section);
      return;
    }

    if ('requestIdleCallback' in window) {
      pager.merlonsRelatedPagerIdle = window.requestIdleCallback(function () {
        delete pager.merlonsRelatedPagerIdle;
        startLoading();
      }, { timeout: 1800 });
    } else {
      pager.merlonsRelatedPagerIdle = window.setTimeout(function () {
        delete pager.merlonsRelatedPagerIdle;
        startLoading();
      }, 1800);
    }
  }

  function cleanupRelatedProducts(root) {
    var scope = root || document;
    var carousels = [];
    if (scope.matches && scope.matches('[data-merlons-related-carousel]')) carousels.push(scope);
    if (scope.querySelectorAll) {
      scope.querySelectorAll('[data-merlons-related-carousel]').forEach(function (carousel) {
        if (carousels.indexOf(carousel) === -1) carousels.push(carousel);
      });
    }
    carousels.forEach(function (carousel) {
      var section = carousel.closest('[data-merlons-related-section]');
      if (section) {
        section.merlonsRelatedLifecycleGeneration = (section.merlonsRelatedLifecycleGeneration || 0) + 1;
      }
      destroyRelatedCarousel(carousel);
      delete carousel.dataset.merlonsRelatedCarouselBound;
      var pager = section && section.querySelector('[data-merlons-related-pager]');
      if (pager) {
        disconnectRelatedPager(pager);
        delete pager.dataset.merlonsRelatedObserved;
        delete pager.dataset.merlonsRelatedLoading;
      }
    });
  }

  async function loadRelatedProducts(pager) {
    if (!pager || pager.dataset.merlonsRelatedLoading === 'true' || !pager.dataset.nextUrl) return;

    var section = pager.closest('[data-merlons-related-section]');
    var grid = section && section.querySelector('[data-merlons-related-grid]');
    var carousel = section && section.querySelector('[data-merlons-related-carousel]');
    if (!section || !grid) return;
    if (typeof section.merlonsRelatedLifecycleGeneration !== 'number') section.merlonsRelatedLifecycleGeneration = 0;
    var lifecycleGeneration = section.merlonsRelatedLifecycleGeneration;
    var isCurrentSection = function () {
      return section.isConnected && section.merlonsRelatedLifecycleGeneration === lifecycleGeneration;
    };

    pager.dataset.merlonsRelatedLoading = 'true';

    try {
      var nextUrl = pager.dataset.nextUrl;
      var visitedUrls = {};
      var fragment = document.createDocumentFragment();
      var pagesLoaded = 0;

      while (nextUrl && !visitedUrls[nextUrl] && pagesLoaded < 100) {
        if (!isCurrentSection() || !pager.isConnected) return;
        visitedUrls[nextUrl] = true;
        var requestUrl = new URL(nextUrl, window.location.origin);
        requestUrl.searchParams.set('section_id', section.dataset.merlonsRelatedSection);
        var response = await fetch(requestUrl.toString(), {
          credentials: 'same-origin',
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });
        if (!response.ok) throw new Error('Related products request failed');

        var responseText = await response.text();
        if (!isCurrentSection() || !pager.isConnected) return;
        var responseDocument = new DOMParser().parseFromString(responseText, 'text/html');
        var sourceSection = responseDocument.querySelector(
          '[data-merlons-related-section="' + section.dataset.merlonsRelatedSection + '"]'
        );
        if (!sourceSection) throw new Error('Related products section missing');

        sourceSection.querySelectorAll('[data-merlons-related-item]').forEach(function (item) {
          fragment.appendChild(item.cloneNode(true));
        });

        var nextPager = sourceSection.querySelector('[data-merlons-related-pager]');
        nextUrl = nextPager && nextPager.dataset.nextUrl ? nextPager.dataset.nextUrl : '';
        pagesLoaded += 1;
      }

      if (!isCurrentSection() || !pager.isConnected) return;

      var slider = carousel && window.jQuery ? window.jQuery(carousel) : null;
      var canUseSlick = slider && carousel.classList.contains('slick-initialized') && typeof slider.slick === 'function';
      if (fragment.childNodes.length) {
        if (canUseSlick) slider.slick('unslick');
        grid.appendChild(fragment);
        if (carousel) {
          startRelatedCarousel(carousel);
          localizeRelatedCarouselArrows(carousel);
        }
      }

      if (window.lazySizes && window.lazySizes.loader && typeof window.lazySizes.loader.checkElems === 'function') {
        window.lazySizes.loader.checkElems();
      }

      pager.remove();
    } catch (error) {
      if (!isCurrentSection() || !pager.isConnected) return;
      pager.dataset.merlonsRelatedLoadFailed = 'true';
      delete pager.dataset.merlonsRelatedLoading;
    }
  }

  function storefrontBundleLanguage() {
    var language = (document.documentElement.lang || 'ka').toLowerCase().split('-')[0];
    if (language === 'en' || language === 'ru' || language === 'ka') return language.toUpperCase();
    return 'KA';
  }

  function nativeBundleRow(component, quantityLabelTemplate) {
    var variant = component && component.productVariant;
    var product = variant && variant.product;
    var url = product && product.onlineStoreUrl;
    var row = document.createElement(url ? 'a' : 'div');
    row.className = 'product-bundle-component';
    if (url) row.href = url;
    row.dataset.merlonsBundleComponentSku = (variant && variant.sku) || '';
    row.dataset.merlonsBundleProductResolved = 'true';

    var article = document.createElement('span');
    article.className = 'product-bundle-component__article';
    article.appendChild(document.createTextNode((variant && variant.sku) || ''));
    var quantity = Number(component && component.quantity) || 1;
    if (quantity > 1) {
      var quantityNode = document.createElement('span');
      quantityNode.textContent = ' × ' + quantity;
      quantityNode.setAttribute('aria-label', quantityLabelTemplate.replace('__quantity__', quantity));
      article.appendChild(quantityNode);
    }

    var name = document.createElement('span');
    name.className = 'product-bundle-component__name';
    name.textContent = (product && product.title) || '';
    row.appendChild(article);
    row.appendChild(name);
    return row;
  }

  function normalizeBundleComponentSku(value) {
    var normalized = String(value || '').trim().toUpperCase();
    return typeof normalized.normalize === 'function' ? normalized.normalize('NFKC') : normalized;
  }

  async function storefrontBundleRequest(query, variables) {
    var shop = window.Shopify && window.Shopify.shop;
    var endpoint = (shop ? 'https://' + shop : window.location.origin) + '/api/2026-07/graphql.json';
    var response = await fetch(endpoint, {
      method: 'POST',
      mode: 'cors',
      credentials: 'omit',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ query: query, variables: variables || {} })
    });
    if (!response.ok) throw new Error('Bundle component product request failed');
    var payload = await response.json();
    if (payload.errors && payload.errors.length) throw new Error('Bundle component product query failed');
    return payload.data || {};
  }

  function bundleComponentSearchQuery(skus) {
    var definitions = skus.map(function (_, index) { return '$q' + index + ': String!'; });
    var fields = skus.map(function (_, index) {
      return [
        'c' + index + ': predictiveSearch(',
        '  query: $q' + index + ',',
        '  limit: 10,',
        '  types: [PRODUCT],',
        '  searchableFields: [VARIANTS_SKU],',
        '  unavailableProducts: SHOW',
        ') {',
        '  products { handle variants(first: 100) { nodes { sku } } }',
        '}'
      ].join('\n');
    });
    return 'query MerlonsBundleComponentSearch(' + definitions.join(', ') + ') @inContext(language: EN) {\n' + fields.join('\n') + '\n}';
  }

  function bundleComponentLocalizedQuery(handles) {
    var definitions = ['$language: LanguageCode'].concat(handles.map(function (_, index) {
      return '$h' + index + ': String!';
    }));
    var fields = handles.map(function (_, index) {
      return 'p' + index + ': product(handle: $h' + index + ') { title onlineStoreUrl }';
    });
    return 'query MerlonsLocalizedBundleComponents(' + definitions.join(', ') + ') @inContext(language: $language) {\n' + fields.join('\n') + '\n}';
  }

  function exactBundleComponentProduct(searchResult, sku) {
    var requestedSku = normalizeBundleComponentSku(sku);
    var products = searchResult && searchResult.products;
    return (products || []).find(function (product) {
      var variants = product && product.variants && product.variants.nodes;
      return (variants || []).some(function (variant) {
        return normalizeBundleComponentSku(variant && variant.sku) === requestedSku;
      });
    });
  }

  function replaceBundleComponentRow(row, product) {
    if (!row || !product || !product.title) return row;
    var name = row.querySelector('.product-bundle-component__name');
    if (name) name.textContent = product.title;

    var resolvedRow = row;
    if (product.onlineStoreUrl) {
      if (row.tagName === 'A') {
        row.href = product.onlineStoreUrl;
      } else {
        resolvedRow = document.createElement('a');
        Array.prototype.forEach.call(row.attributes, function (attribute) {
          resolvedRow.setAttribute(attribute.name, attribute.value);
        });
        while (row.firstChild) resolvedRow.appendChild(row.firstChild);
        resolvedRow.href = product.onlineStoreUrl;
        row.replaceWith(resolvedRow);
      }
    }
    resolvedRow.dataset.merlonsBundleProductResolved = 'true';
    return resolvedRow;
  }

  async function resolveBundleComponentProducts(root) {
    var scope = root || document;
    var rows = Array.prototype.slice.call(scope.querySelectorAll(
      '[data-merlons-bundle-component-sku][data-merlons-bundle-product-resolved="false"]'
    ));
    if (!rows.length) return;

    var skuMap = new Map();
    rows.forEach(function (row) {
      var sku = normalizeBundleComponentSku(row.dataset.merlonsBundleComponentSku);
      if (!sku) return;
      if (!skuMap.has(sku)) skuMap.set(sku, []);
      skuMap.get(sku).push(row);
      row.dataset.merlonsBundleProductResolved = 'loading';
    });
    var skus = Array.from(skuMap.keys());
    if (!skus.length) return;

    try {
      var searchVariables = {};
      skus.forEach(function (sku, index) { searchVariables['q' + index] = sku; });
      var searchData = await storefrontBundleRequest(bundleComponentSearchQuery(skus), searchVariables);
      var foundBySku = new Map();
      skus.forEach(function (sku, index) {
        var match = exactBundleComponentProduct(searchData['c' + index], sku);
        if (match && match.handle) foundBySku.set(sku, match.handle);
      });
      var handles = Array.from(new Set(foundBySku.values()));
      if (!handles.length) return;

      var localizedVariables = { language: storefrontBundleLanguage() };
      handles.forEach(function (handle, index) { localizedVariables['h' + index] = handle; });
      var localizedData = await storefrontBundleRequest(bundleComponentLocalizedQuery(handles), localizedVariables);
      var localizedByHandle = new Map();
      handles.forEach(function (handle, index) {
        var product = localizedData['p' + index];
        if (product && product.title) localizedByHandle.set(handle, product);
      });

      foundBySku.forEach(function (handle, sku) {
        var product = localizedByHandle.get(handle);
        if (!product) return;
        (skuMap.get(sku) || []).forEach(function (row) { replaceBundleComponentRow(row, product); });
      });
    } catch (error) {
      rows.forEach(function (row) { row.dataset.merlonsBundleProductResolved = 'failed'; });
    } finally {
      rows.forEach(function (row) {
        if (row.dataset.merlonsBundleProductResolved === 'loading') {
          row.dataset.merlonsBundleProductResolved = 'unpublished';
        }
      });
    }
  }

  // Informational only: reuse the signed, publication-gated app proxy. No cart
  // changes or inventory reservations. Share in-flight requests across sections.
  var managedBundleComponentRequests = new Map();
  function resolvedBundleComponentFallbacks(list) {
    var fallbacks = new Map();
    Array.prototype.forEach.call(list.querySelectorAll(
      '[data-merlons-bundle-component-sku][data-merlons-bundle-product-resolved="true"]'
    ), function (row) {
      var sku = String(row.dataset.merlonsBundleComponentSku || '').trim();
      var name = row.querySelector('.product-bundle-component__name');
      var title = name && name.textContent && name.textContent.trim();
      if (sku && title) {
        if (fallbacks.has(sku)) { fallbacks.set(sku, null); return; }
        fallbacks.set(sku, {
          title: title,
          onlineStoreUrl: row.tagName === 'A' && row.href ? row.href : null
        });
      }
    });
    return fallbacks;
  }
  async function loadManagedBundleComponents(shell, variantId) {
    if (!/^gid:\/\/shopify\/ProductVariant\/[1-9][0-9]*$/.test(variantId)) return;
    var cached = managedBundleComponentRequests.get(variantId);
    if (!cached || cached.expires <= Date.now()) {
      var key = 'merlons-product-components:' + variantId.split('/').pop();
      cached = { expires: Date.now() + 60000 };
      cached.promise = (async function () {
        var response = await fetch('/apps/merlons-bundles/components', {
          method: 'POST', credentials: 'same-origin', cache: 'no-store',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          signal: AbortSignal.timeout(15000),
          body: JSON.stringify({ lines: [{ key: key, variantId: variantId, quantity: 1 }] })
        });
        if (!response.ok) throw new Error('Bundle component request failed');
        var payload = await response.json();
        var line = payload && Array.isArray(payload.lines) && payload.lines.length === 1 && payload.lines[0];
        if (!line || payload.reservation !== false || line.key !== key || line.variantId !== variantId || line.quantity !== 1
          || line.bundle !== true || !Array.isArray(line.components) || !line.components.length || line.components.length > 30
          || !Array.isArray(payload.issues) || typeof payload.ok !== 'boolean'
          || payload.ok !== (payload.issues.length === 0)) throw new Error('Invalid bundle component response');
        var seen = new Set();
        line.components.forEach(function (component) {
          if (!component || !/^gid:\/\/shopify\/ProductVariant\/[1-9][0-9]*$/.test(component.variantId)
            || seen.has(component.variantId) || typeof component.sku !== 'string' || !component.sku.trim()
            || typeof component.title !== 'string' || !component.title.trim()
            || !Number.isSafeInteger(component.quantity) || component.quantity < 1 || component.quantity > 1000) {
            throw new Error('Invalid bundle component');
          }
          seen.add(component.variantId);
        });
        // Sold-out bundles still need their complete informational component list.
        if (payload.issues.some(function (issue) {
          return !issue || issue.code !== 'insufficient-component-stock' || !seen.has(issue.variantId);
        })) throw new Error('Bundle definition unavailable');
        return line.components;
      })();
      managedBundleComponentRequests.set(variantId, cached);
    }
    try {
      var components = await cached.promise;
      if (shell.dataset.merlonsBundleVariantId !== variantId || !shell.isConnected) return;
      var list = shell.querySelector('.product-bundle-components');
      if (!list) return;
      var resolvedFallbacks = resolvedBundleComponentFallbacks(list);
      var localizeFreshRows = storefrontBundleLanguage() !== 'KA';
      var fragment = document.createDocumentFragment();
      components.forEach(function (component) {
        var fallback = resolvedFallbacks.get(component.sku.trim());
        var row = nativeBundleRow({ quantity: component.quantity,
          productVariant: { sku: component.sku, product: {
            title: fallback ? fallback.title : component.title,
            onlineStoreUrl: fallback && fallback.onlineStoreUrl
          } } },
          shell.dataset.merlonsBundleQuantityLabel || '__quantity__');
        if (localizeFreshRows && !fallback) row.dataset.merlonsBundleProductResolved = 'false';
        fragment.appendChild(row);
      });
      list.replaceChildren(fragment);
      shell.dataset.merlonsBundleResolved = 'true';
      shell.dataset.merlonsBundleNative = 'true';
      delete shell.dataset.merlonsBundleRequestFailed;
      shell.hidden = false;
      if (localizeFreshRows) resolveBundleComponentProducts(list);
    } catch (error) {
      if (managedBundleComponentRequests.get(variantId) === cached) managedBundleComponentRequests.delete(variantId);
      if (shell.dataset.merlonsBundleVariantId === variantId) shell.dataset.merlonsBundleRequestFailed = 'true';
      // Preserve server-rendered fallback on outages; never replace it with an
      // incomplete list, and do not affect the purchase/request controls.
    }
  }

  async function loadNativeBundleComponents(shell, variantId) {
    if (shell && shell.dataset.merlonsBundleNativeCandidate === 'true') return loadManagedBundleComponents(shell, variantId);
    if (!shell || !variantId || shell.dataset.merlonsBundleLoading === 'true') return;
    if (shell.dataset.merlonsBundleCheckedVariant === variantId) return;
    shell.dataset.merlonsBundleLoading = 'true';

    var shop = window.Shopify && window.Shopify.shop;
    var endpoint = (shop ? 'https://' + shop : window.location.origin) + '/api/2026-07/graphql.json';
    var query = [
      'query MerlonsBundleComponents($id: ID!, $language: LanguageCode) @inContext(language: $language) {',
      '  node(id: $id) {',
      '    ... on ProductVariant {',
      '      requiresComponents',
      '      components(first: 100) {',
      '        nodes {',
      '          quantity',
      '          productVariant { sku product { title onlineStoreUrl } }',
      '        }',
      '      }',
      '    }',
      '  }',
      '}'
    ].join('\n');

    try {
      var response = await fetch(endpoint, {
        method: 'POST',
        mode: 'cors',
        credentials: 'omit',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          query: query,
          variables: { id: variantId, language: storefrontBundleLanguage() }
        })
      });
      if (!response.ok) throw new Error('Bundle component request failed');
      var payload = await response.json();
      if (payload.errors && payload.errors.length) throw new Error('Bundle component query failed');

      var bundleVariant = payload.data && payload.data.node;
      var components = bundleVariant && bundleVariant.components && bundleVariant.components.nodes;
      shell.dataset.merlonsBundleCheckedVariant = variantId;
      if (!bundleVariant || !bundleVariant.requiresComponents || !components || !components.length) return;

      var list = shell.querySelector('.product-bundle-components');
      if (!list) return;
      list.textContent = '';
      var quantityLabelTemplate = shell.dataset.merlonsBundleQuantityLabel || 'Quantity: __quantity__';
      components.forEach(function (component) {
        list.appendChild(nativeBundleRow(component, quantityLabelTemplate));
      });
      shell.dataset.merlonsBundleResolved = 'true';
      shell.dataset.merlonsBundleNative = 'true';
      shell.hidden = false;
    } catch (error) {
      shell.dataset.merlonsBundleRequestFailed = 'true';
    } finally {
      delete shell.dataset.merlonsBundleLoading;
    }
  }

  function initializeNativeBundleComponents(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-merlons-bundle-components][data-merlons-bundle-resolved="false"], [data-merlons-bundle-components][data-merlons-bundle-native-candidate="true"]').forEach(function (shell) {
      loadNativeBundleComponents(shell, shell.dataset.merlonsBundleVariantId);
    });
  }

  function refreshNativeBundleForControl(control) {
    var productScope = control.closest('.product-template__container, .product-single, [data-section-id]') || document;
    var shell = productScope.querySelector('[data-merlons-bundle-components]');
    var form = control.closest('form');
    var variantInput = form && form.querySelector('input[name="id"]');
    if (!shell || !variantInput || !variantInput.value) return;
    var variantId = 'gid://shopify/ProductVariant/' + variantInput.value;
    if (shell.dataset.merlonsBundleVariantId === variantId) return;
    shell.dataset.merlonsBundleVariantId = variantId;
    loadNativeBundleComponents(shell, variantId);
  }

  async function buyNow(button) {
    var form = button.closest('form');
    if (!form || button.disabled || !variantIsAvailable(form)) return;

    var variantInput = form.querySelector('input[name="id"]');
    if (!variantInput || !variantInput.value) return;

    var quantityInput = form.querySelector('input[name="quantity"]');
    if (quantityInput) normaliseQuantity(quantityInput);

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    try {
      var response = await fetch(button.dataset.cartAddUrl || form.action, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
        credentials: 'same-origin'
      });
      var payload = await response.json().catch(function () { return {}; });
      if (!response.ok || payload.status) throw new Error(addErrorMessage(button) || payload.description || payload.message);

      button.disabled = false;
      button.removeAttribute('aria-busy');
      if (window.MerlonsOrderRequest && typeof window.MerlonsOrderRequest.open === 'function') {
        window.MerlonsOrderRequest.open(button);
      } else {
        document.dispatchEvent(new CustomEvent('merlons:order-request:open'));
      }
    } catch (error) {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      var message = error && error.message ? error.message : addErrorMessage(button);
      if (message) window.alert(message);
    }
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('.item-swatch li label')) queueCollectionCardVariantSync(event.target);

    var sku = event.target.closest('[data-merlons-copy-sku]');
    if (sku) {
      event.preventDefault();
      sku.focus({ preventScroll: true });
      copySku(sku);
      return;
    }

    var quantityButton = event.target.closest('[data-merlons-quantity-button]');
    if (quantityButton) {
      event.preventDefault();
      event.stopImmediatePropagation();
      setQuantity(quantityButton.closest('.quick_view_qty'), quantityButton.dataset.merlonsQuantityButton);
      return;
    }

    var buyNowButton = event.target.closest('[data-merlons-buy-now]');
    if (buyNowButton) {
      event.preventDefault();
      buyNow(buyNowButton);
    }
  }, true);

  document.addEventListener('contextmenu', function (event) {
    var sku = event.target.closest('[data-merlons-copy-sku]');
    if (!sku || sku.dataset.merlonsCopyOnContextmenu === 'false') return;
    event.preventDefault();
    sku.focus({ preventScroll: true });
    copySku(sku);
  }, true);

  document.addEventListener('keydown', function (event) {
    var sku = event.target.closest('[data-merlons-copy-sku]');
    if (!sku || (event.key !== 'Enter' && event.key !== ' ')) return;
    event.preventDefault();
    copySku(sku);
  });

  document.addEventListener('change', function (event) {
    if (event.target.matches('input[name="quantity"]')) normaliseQuantity(event.target);
    if (event.target.matches('input[name="id"], select, input[type="radio"]')) {
      window.setTimeout(function () {
        updateAllBuyNow();
        refreshNativeBundleForControl(event.target);
        queueCollectionCardVariantSync(event.target);
      }, 0);
    }
  });

  function initializeProductActions() {
    updateAllBuyNow();
    initializeRelatedProducts(document);
    initializeNativeBundleComponents(document);
    resolveBundleComponentProducts(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeRelatedProducts(event.target);
    initializeNativeBundleComponents(event.target);
    resolveBundleComponentProducts(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    cleanupRelatedProducts(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeProductActions);
  } else {
    initializeProductActions();
  }
}());
